export enum EntityStatus {
    Archived = "archived",
    Draft = "draft",
    Published = "published",
    Stopped = "stopped"
}

